import React, { createContext, useContext, useState, ReactNode } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useCurrentUser, UserProfile, AUTH_QUERY_KEYS } from '@/hooks/queries/query/auth'

interface UserContextType {
  user: UserProfile | null
  isLoading: boolean
  showUserMenu: boolean
  setShowUserMenu: (show: boolean) => void
  logout: () => void
}

const UserContext = createContext<UserContextType | undefined>(undefined)

export const useUser = () => {
  const context = useContext(UserContext)
  if (!context) throw new Error('useUser must be used within a UserProvider')
  return context
}

interface UserProviderProps {
  children: ReactNode
}

export const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
  const [showUserMenu, setShowUserMenu] = useState(false)
  const queryClient = useQueryClient()
  const { data: user, isLoading } = useCurrentUser()

  const logout = () => {
    void fetch('/api/auth/logout', { method: 'POST', credentials: 'include' })
    queryClient.removeQueries({ queryKey: AUTH_QUERY_KEYS.me })
    window.location.href = '/login'
  }

  return (
    <UserContext.Provider value={{ user: user ?? null, isLoading, showUserMenu, setShowUserMenu, logout }}>
      {children}
    </UserContext.Provider>
  )
}

